import { render, staticRenderFns } from "./ModalApprovePayment.vue?vue&type=template&id=0af1f719&scoped=true&"
import script from "./ModalApprovePayment.vue?vue&type=script&lang=ts&"
export * from "./ModalApprovePayment.vue?vue&type=script&lang=ts&"
import style0 from "./ModalApprovePayment.vue?vue&type=style&index=0&id=0af1f719&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af1f719",
  null
  
)

export default component.exports